import {
	Component,
	OnInit,
	Input,
	OnChanges,
	Output,
	EventEmitter
} from '@angular/core';
import { FormBuilder, FormArray } from '@angular/forms';

import { Division } from '../../interfaces/index';
import { includes } from '../../../shared';

@Component({
	selector: 'eze-select-divisions',
	templateUrl: './select-divisions.component.html',
	styleUrls: ['./select-divisions.component.css']
})
export class SelectDivisionsComponent implements OnInit, OnChanges {
	@Input()
	divisions: Division[];

	form: FormArray = this.fb.array([]);

	formChanges;

	@Output()
	selectDivision = new EventEmitter<number[]>();

	constructor(private fb: FormBuilder) {}

	ngOnInit() {
		this.initForm();
	}

	ngOnChanges() {
		this.initForm();
	}

	initForm() {
		const controls = this.divisions.map(d => {
			return this.fb.control(false);
		});
		this.form = this.fb.array(controls);

		if (this.formChanges && this.formChanges.unsubscribe) {
			this.formChanges.unsubscribe();
		}
		this.formChanges = this.form.valueChanges.subscribe(value => {
			this.selectDivision.emit(this.selectedDivisionIds);
		});
	}

	generateName(division: Division): string {
		if (division.description.replace(/\s/g, '')) {
			return `${division.name} - ${division.description}`; // + `id = ${division.id} - exclusions =${division.exclusions}`;
		} else {
			return `${division.name}`;
		}
	}

	get selectedDivisions(): Division[] {
		const formValue = this.form.value as Array<boolean>;

		const selectedIdxs = formValue
			.map((element, i) => {
				return { value: element, index: i };
			})
			.filter(element => element.value)
			.map(element => element.index);

		return selectedIdxs.map(i => this.divisions[i]);
	}

	get selectedDivisionIds(): number[] {
		return this.selectedDivisions.map(division => division.id);
	}

	get exclusions(): number[] {
		return this.selectedDivisions
			.map(division => division.exclusions)
			.filter(arr => arr.length !== 0)
			.join(',')
			.split(',')
			.map(num => Number(num));
	}

	includes(arr, element) {
		return includes(arr, element);
	}
}
